var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramOnline48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./Online48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "pictogramOnline48",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75,21.75 L22.25,21.75 L22.25,9.75 L16,9.75 C12.5482203,9.75 9.75,12.5482203 9.75,16 L9.75,21.75 Z",
    id: "Focus",
    stroke: "#4F4C4D",
    strokeWidth: 1.5,
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75,21.75 L33.25,21.75 L33.25,9.75 L28,9.75 C24.5482203,9.75 21.75,12.5482203 21.75,16 L21.75,21.75 Z",
    id: "Right-button",
    stroke: "#4F4C4D",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    transform: "translate(27.500000, 15.750000) scale(-1, 1) translate(-27.500000, -15.750000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Emphasis",
    transform: "translate(0.829548, 0.769201)",
    fill: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Emphasis-bottom",
    x: 0.170451625,
    y: 10.2307986,
    width: 6,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Emphasis-top",
    x: 10.1704516,
    y: 0.230798608,
    width: 1.5,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Emphasis-middle",
    transform: "translate(4.822102, 4.852119) rotate(-45.000000) translate(-4.822102, -4.852119) ",
    x: 4.07210205,
    y: 1.85211895,
    width: 1.5,
    height: 6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9.75,21.75 L9.75,33.9942702 C9.75,40.2183913 14.7850911,45.25 21.0057298,45.25 L21.9942702,45.25 C28.2183913,45.25 33.25,40.2149089 33.25,33.9942702 L33.25,21.75 L9.75,21.75 Z",
    id: "Mouse",
    stroke: "#4F4C4D",
    strokeWidth: 1.5,
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramOnline48);
export default __webpack_public_path__ + "static/media/pictogramOnline48.cc81924158faecc93c391bcd638d550d.svg";
export { ForwardRef as ReactComponent };